module.exports = __webpack_public_path__ + "static/media/0015.0014b83a.jpg";